import { compose } from 'ramda';
import { mapProps } from 'recompose';
import * as DOMUtils from 'js/utils/DOM.util';
import { sanitize } from 'dompurify';
import style from './index.scss';

export const sanitizeTopPrizes = ({ topPrizes }) => topPrizes && topPrizes.map((prize) => {
    const { longDescription } = prize;

    if (longDescription && DOMUtils.isHtml(longDescription)) {
        return {
            ...prize,
            className: style.prizeHtml,
            longDescription: sanitize(longDescription)
        };
    }

    return {
        ...prize,
        className: style.prizeText
    };
});

export default compose(
    mapProps(
        ({ topPrizes, commonPrize, ...rest }) => {
            let nextCommonPrize = commonPrize;
            let commonPrizeClassName = style.commonPrizeText;
            const nextTopPrizes = sanitizeTopPrizes({ sanitize, topPrizes });

            if (commonPrize && DOMUtils.isHtml(commonPrize)) {
                nextCommonPrize = sanitize(commonPrize);
                commonPrizeClassName = null;
            }

            return {
                ...rest,
                commonPrizeClassName,
                commonPrize: nextCommonPrize,
                topPrizes: nextTopPrizes
            };
        }
    )
);
